<div class="captcha-mobile">
    <div class="captcha-container" *ngIf="backgroundUrl && puzzleUrl">
        <div class="image-wrapper">
          <img [src]="backgroundUrl" class="bg-image" />
          <img [src]="puzzleUrl" class="puzzle-piece" [ngStyle]="{ left: offsetX + 'px', top: offsetY + 'px' }" #puzzle />
          <span class="reload" *ngIf="isVerified !== 'success'"  (click)="loadCaptcha()" matTooltip="{{'slide_captcha.tooltips.reload' | translate }}">
            <i style="font-size: 18px; color: #ee0033;" nz-icon nzType="reload" nzTheme="outline"></i>
          </span>
        </div>
        <div class="slider-bar">
          <div class="slider-progress" [ngStyle]="{ width: offsetX + 'px', backgroundColor: backgroundProgress }"></div>
      
          <div class="slider-background"></div>
      
          <div *ngIf="isVerified !== 'success'" 
              class="slider-button"
              (mousedown)="startDrag($event)"
              (touchstart)="startDrag($event)"
              [ngStyle]="{ left: offsetX + 'px', backgroundColor: isVerified === 'error' ? '#f35c59' : ''}"
              #slider>
            <i *ngIf="isVerified === ''" nz-icon nzType="arrow-right" nzTheme="outline"></i>
            <!-- <i *ngIf="isVerified === 'success'" style="color: white;" nz-icon nzType="check" nzTheme="outline"></i> -->
            <i *ngIf="isVerified === 'error'" style="color: white;" nz-icon nzType="close" nzTheme="outline"></i>
          </div>
          <div *ngIf="isVerified === 'success'" class="slider-button"
              [ngStyle]="{ left: offsetX + 'px', backgroundColor: '#02c076' }"
              #slider>
            <i style="color: white;" nz-icon nzType="check" nzTheme="outline"></i>
          </div>
        </div>
      </div>
</div>
  